import { rgbToLab } from '../color/srgb-lab';
import type { RgbColor } from '../color/types';
import type { BeadColor } from './types';

/** Parse un hex sRGB (avec ou sans préfixe #) en RgbColor. */
export function hexToRgb(hex: string): RgbColor {
  const cleaned = hex.replace(/^#/, '');
  if (!/^[0-9a-fA-F]{6}$/.test(cleaned)) {
    throw new Error(`Code hex invalide : "${hex}" (attendu : 6 chiffres hexadécimaux)`);
  }
  return {
    r: parseInt(cleaned.slice(0, 2), 16),
    g: parseInt(cleaned.slice(2, 4), 16),
    b: parseInt(cleaned.slice(4, 6), 16),
  };
}

/**
 * Construit une BeadColor avec son LAB précalculé.
 * À utiliser au moment de déclarer le catalogue.
 */
export function defineColor(args: {
  id: string;
  name: string;
  rgb: RgbColor;
  notes?: string;
}): BeadColor {
  const { id, name, rgb, notes } = args;
  const base: BeadColor = {
    id,
    name,
    rgb,
    lab: rgbToLab(rgb),
  };
  return notes === undefined ? base : { ...base, notes };
}

/** Variante pratique : déclaration via hex. */
export function defineColorHex(args: {
  id: string;
  name: string;
  hex: string;
  notes?: string;
}): BeadColor {
  const { id, name, hex, notes } = args;
  return defineColor({ id, name, rgb: hexToRgb(hex), ...(notes !== undefined ? { notes } : {}) });
}
